module.exports = __webpack_public_path__ + "img/5562.3fe754fa.jpg";